// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

// ** Toast Imports
import { toast } from 'react-toastify';

export const getSalaryRule = createAsyncThunk('salaryRuleSliceData/getSalaryRule', async () => {
    try {
        let response = await axios.get('/salaryrules', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getSalaryRuleOption = createAsyncThunk('salaryRuleSliceData/getSalaryRuleOption', async () => {
    try {
        let response = await axios.get('/salaryrules?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getSalaryRuleId = createAsyncThunk('salaryRuleSliceData/getSalaryRuleId', async (id) => {
    try {
        let response = await axios.get('/salaryrules/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteSalaryRule = createAsyncThunk('salaryRuleSliceData/deleteSalaryRule', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/salaryrules/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'salaryrules deleted successfully.');
        await dispatch(getSalaryRule());
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createSalaryRule = createAsyncThunk('salaryRuleSliceData/createSalaryRule', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/salaryrules', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'salaryrules added succesfully.');
        await dispatch(getSalaryRule());
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateSalaryRule = createAsyncThunk('salaryRuleSliceData/updateSalaryRule', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/salaryrules/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'salaryrules updated succesfully.');
        await dispatch(getSalaryRule());
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateSalaryRuleStatus = createAsyncThunk('salaryRuleSliceData/updateSalaryRuleStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put(
            '/SalaryRules/status/' + id,
            {},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getSalaryRule());
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
  

//fetch employees for bulk assign modal
export const getEmployee = createAsyncThunk('salaryRuleSliceData/getEmployee', async () => {
    try {
        let response = await axios.get('/Employee', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// Bulk assign salary rules to employees

export const bulkAssignSalaryRule = createAsyncThunk('salaryRuleSliceData/bulkAssignSalaryRule', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/salaryrules/assign-salary-policy', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Salary Rules assigned successfully.');
        await dispatch(getSalaryRule());
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getAssignedSalaryRuleEmployees = createAsyncThunk('salaryRuleSliceData/getAssignedSalaryRuleEmployees', async (id) => {
    try {
        let response = await axios.get('/SalaryRules/assigned-employee/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const salaryRuleSlice = createSlice({
    name: 'salaryRuleSliceData',
    initialState: {
        salaryRule: [],
        salaryRuleOption: [],
        employeeList: []
    },
    extraReducers: (builder) => {
        builder.addCase(getSalaryRule.fulfilled, (state, action) => {
            state.salaryRule = action?.payload;
            return;
        });
        builder.addCase(getSalaryRuleOption.fulfilled, (state, action) => {
            state.salaryRuleOption = action?.payload;
            return;
        });
        builder.addCase(getEmployee.fulfilled, (state, action) => {
            state.employeeList = action?.payload;
            return;
        });
    }
});

export default salaryRuleSlice.reducer;
